import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {DeleteWorkflowRequest} from './contracts'

export async function apiDeleteWorkflow(body: DeleteWorkflowRequest): Promise<void> {
  const apiData = getApiMetadata('memex-workflow-delete-api-data')

  await fetchJSONWith<void>(apiData.url, {
    method: 'DELETE',
    body,
  })
}
